module.exports = __webpack_public_path__ + "img/p2-43.ba9bcd41.png";